import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { TextFormat, Translate } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity } from './block-screen.reducer';

export const BlockScreenDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const blockScreenEntity = useAppSelector(state => state.blockScreen.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="blockScreenDetailsHeading">
          <Translate contentKey="fleetSenseApp.blockScreen.detail.title">BlockScreen</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{blockScreenEntity.id}</dd>
          <dt>
            <span id="show">
              <Translate contentKey="fleetSenseApp.blockScreen.show">Show</Translate>
            </span>
          </dt>
          <dd>{blockScreenEntity.show ? 'true' : 'false'}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="fleetSenseApp.blockScreen.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{blockScreenEntity.createdBy}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="fleetSenseApp.blockScreen.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>{blockScreenEntity.createdDate ? <TextFormat value={blockScreenEntity.createdDate} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="lastModifiedBy">
              <Translate contentKey="fleetSenseApp.blockScreen.lastModifiedBy">Last Modified By</Translate>
            </span>
          </dt>
          <dd>{blockScreenEntity.lastModifiedBy}</dd>
          <dt>
            <span id="lastModifiedDate">
              <Translate contentKey="fleetSenseApp.blockScreen.lastModifiedDate">Last Modified Date</Translate>
            </span>
          </dt>
          <dd>{blockScreenEntity.lastModifiedDate ? <TextFormat value={blockScreenEntity.lastModifiedDate} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.blockScreen.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{blockScreenEntity.truckImplement ? blockScreenEntity.truckImplement.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/block-screen" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/block-screen/${blockScreenEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BlockScreenDetail;
